/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import { Box, Typography, Stack } from "@mui/material";
import PendingSkeleton from "src/components/pages/dashboard/skeleton/dashboard/PendingTable";
import ReactApexChart from "react-apexcharts";
import { addDays, format, parse } from "date-fns";
import { useLazyQuery, useSubscription } from "@apollo/client";
import { useSnackbar as Snackbar } from "notistack";
import GETCHATCOUNTPERPAGEPERDAY from "src/graphql/query/dashboard/GraphicalChart/getChatCountPerPagePerDay";
import CHATCOUNTPERPAGEPERDAYSUBSCRIPTION from "src/graphql/subscriptions/dashboard/getchatcountperpageperday";
import { UseDashboardContext } from "src/context/dashboard";
import { safeJsonParse } from "src/utils/shared/safeJson";
import { useFeature } from "src/context/global";
import useStyles from "./Styles";

const Graph: React.FC = () => {
  const { classes } = useStyles();
  const { canUse } = useFeature();
  const canSeeChatbot = canUse("see_chatbot_conversations");

  const { enqueueSnackbar } = Snackbar();
  const contextData = UseDashboardContext();
  let totalChatsGraphData: any;
  let setTotalChatsGraphData: (a: any) => void;
  let setTotalChatsGraphDataLoading: (a: boolean) => void;
  let storedAgentId: number = 0;

  let timePeriod: string = "";

  if (contextData) {
    ({
      timePeriod,
      totalChatsGraphData,
      setTotalChatsGraphDataLoading,
      setTotalChatsGraphData,
      storedAgentId,
    } = contextData);
  }

  const [next7Days, setNext7Days] = useState<any>([]);

  useEffect(() => {
    // Function to get the date for the next 7 days
    function getNext7Days() {
      const today = new Date();
      const next7Days = [];

      for (let i = 0; i > -7; i -= 1) {
        const date = addDays(today, i);
        next7Days.push({ date: format(date, "yyyy-MM-dd"), count: 0 });
      }
      return next7Days;
    }
    setNext7Days(getNext7Days());
  }, []);

  const convertToDay = (date: string) => {
    const yourDate = parse(date, "yyyy-MM-dd", new Date());
    return format(yourDate, "EEEE");
  };
  const facebook = new Map();
  const whatsapp = new Map();
  const instagram = new Map();
  const chatbot = new Map(); // New map for chatbot

  if (totalChatsGraphData && totalChatsGraphData.length > 0) {
    totalChatsGraphData.forEach((dataObject: any) => {
      if (dataObject.source === "facebook") {
        // setting count against date in the map
        if (facebook.has(dataObject.date)) {
          const val = facebook.get(dataObject.date) + dataObject.count;
          facebook.set(dataObject.date, val);
        } else {
          facebook.set(dataObject.date, dataObject.count);
        }
      } else if (dataObject.source === "whatsapp") {
        if (whatsapp.has(dataObject.date)) {
          const val = whatsapp.get(dataObject.date) + dataObject.count;
          whatsapp.set(dataObject.date, val);
        } else {
          whatsapp.set(dataObject.date, dataObject.count);
        }
      } else if (dataObject.source === "instagram") {
        if (instagram.has(dataObject.date)) {
          const val = instagram.get(dataObject.date) + dataObject.count;
          instagram.set(dataObject.date, val);
        } else {
          instagram.set(dataObject.date, dataObject.count);
        }
      } else if (
        dataObject.source === "widget" ||
        dataObject.source === "chatbot"
      ) {
        // In case backend sends it
        if (chatbot.has(dataObject.date)) {
          const val = chatbot.get(dataObject.date) + dataObject.count;
          chatbot.set(dataObject.date, val);
        } else {
          chatbot.set(dataObject.date, dataObject.count);
        }
      }
    });
  }

  const facebookData = Object.fromEntries(facebook);
  const whatsappData = Object.fromEntries(whatsapp);
  const instagramData = Object.fromEntries(instagram);
  const chatbotData = Object.fromEntries(chatbot);

  const facebookCounts = next7Days.map((item: { date: string | number }) => {
    let count = 0;
    if (facebookData[item.date]) {
      count = facebookData[item.date];
    }
    return { ...item, count };
  });

  const whatsappCounts = next7Days.map((item: { date: string | number }) => {
    let count = 0;
    if (whatsappData[item.date]) {
      count = whatsappData[item.date];
    }
    return { ...item, count };
  });

  const instagramCounts = next7Days.map((item: { date: string | number }) => {
    let count = 0;
    if (instagramData[item.date]) {
      count = instagramData[item.date];
    }
    return { ...item, count };
  });

  const chatbotCounts = next7Days.map((item: { date: string | number }) => {
    let count = 0;
    if (chatbotData[item.date]) {
      count = chatbotData[item.date];
    }
    return { ...item, count };
  });

  const facebookVertical = facebookCounts.map(
    (item: { count: any }) => item.count,
  );
  const whatsappVertical = whatsappCounts.map(
    (item: { count: any }) => item.count,
  );
  const instagramVertical = instagramCounts.map(
    (item: { count: any }) => item.count,
  );
  const chatbotVertical = chatbotCounts.map(
    (item: { count: any }) => item.count,
  );
  const horizontal = facebookCounts.map((item: { date: any }) =>
    convertToDay(item.date),
  );

  const zeroArray = next7Days.map(() => 0);

  const seriesColors: Record<string, string> = {
    Facebook: "#1877F2", // Blue
    Whatsapp: "#60D669", // Green
    Instagram: "#B336AA", // Purple
    Chatbot: "#FF9800", // Orange
  };

  const rawSeries = Object.entries({
    Facebook: facebookVertical.length > 0 ? facebookVertical : zeroArray,
    Whatsapp: whatsappVertical.length > 0 ? whatsappVertical : zeroArray,
    Instagram: instagramVertical.length > 0 ? instagramVertical : zeroArray,
    Chatbot: chatbotVertical.length > 0 ? chatbotVertical : zeroArray,
  }).map(([name, data]) => ({
    name,
    data,
  }));

  const filteredSeries = rawSeries.filter((s) =>
    s.data.some((val: any) => val > 0),
  );
  const series = filteredSeries.length > 0 ? filteredSeries : rawSeries;

  const dynamicColors = series.map((s) => seriesColors[s.name]);

  const options = useMemo(() => {
    const allCounts = [
      ...facebookVertical,
      ...whatsappVertical,
      ...instagramVertical,
      ...chatbotVertical,
    ].filter(
      (num) => typeof num === "number" && !Number.isNaN(num) && num !== null,
    );

    const maxValue = allCounts.length > 0 ? Math.max(...allCounts) : 0;
    const safeMax = maxValue > 0 ? maxValue : 1;
    const safeTickAmount = maxValue > 0 ? Math.min(maxValue, 5) : 1;

    return {
      chart: {
        type: "line" as const,
        toolbar: { show: false },
        zoom: { enabled: false },
        animations: {
          enabled: true,
          dynamicAnimation: { enabled: false }, // Prevents null crash on resize/re-render
        },
        redrawOnWindowResize: false, // Prevent resize-triggered null crashes
      },
      grid: {
        padding: {
          left: 10,
          right: 10,
        },
      },
      xaxis: {
        categories: horizontal.length > 0 ? horizontal : [""],
        labels: {
          style: {
            fontFamily: "Poppins",
            fontSize: "14px",
            colors: "#999999",
          },
        },
      },
      yaxis: {
        min: 0,
        max: safeMax,
        tickAmount: safeTickAmount,
        // forceNiceScale removed — causes null tick values during resize in ApexCharts
        labels: {
          formatter: (val: any) => {
            if (
              val == null ||
              val === undefined ||
              !Number.isFinite(Number(val))
            )
              return "";
            const n = Number(val);
            return Number.isInteger(n) ? n.toString() : "";
          },
          style: {
            fontFamily: "Poppins",
            fontSize: "16px",
            colors: "#999999",
          },
        },
      },
      markers: {
        size: 7,
        shape: "circle" as const,
        strokeWidth: 2,
        strokeColors: dynamicColors.map((c) => c || "#ccc"),
        fillOpacity: 1,
        colors: ["#ffffff"],
        hover: {
          sizeOffset: 2,
        },
      },
      stroke: {
        curve: "straight" as const,
        width: 2,
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      legend: {
        show: true,
        position: "bottom" as const,
      },
      colors: dynamicColors.map((c) => c || "#ccc"),
      dataLabels: {
        enabled: false,
      },
    };
  }, [
    facebookVertical,
    whatsappVertical,
    instagramVertical,
    chatbotVertical,
    horizontal,
    dynamicColors,
  ]);

  const [
    getChatCountForSocialMedia,
    { data: graphDataResult, loading: graphDataLoading },
  ] = useLazyQuery(GETCHATCOUNTPERPAGEPERDAY, {
    fetchPolicy: "network-only",
  });

  const {
    data: chatCountPerPagePerDaySubscriptionResult,
    error: chatCountPerPagePerDaySubscriptionError,
  } = useSubscription(CHATCOUNTPERPAGEPERDAYSUBSCRIPTION);

  useEffect(() => {
    if (chatCountPerPagePerDaySubscriptionError) {
      enqueueSnackbar(chatCountPerPagePerDaySubscriptionError.message, {
        variant: "error",
      });
    }
  }, [chatCountPerPagePerDaySubscriptionError]);

  useEffect(() => {
    if (chatCountPerPagePerDaySubscriptionResult) {
      const parsedResult = safeJsonParse<any>(
        chatCountPerPagePerDaySubscriptionResult.getdashboardchatcountperpage
          .result,
        { agentId: null, data: [] },
        "Graph Updates",
      );
      const { agentId, data } = parsedResult;
      if (storedAgentId === agentId) {
        const filteredData = data.filter(
          (item: any) =>
            !(
              (item.source === "widget" || item.source === "chatbot") &&
              !canSeeChatbot
            ),
        );
        setTotalChatsGraphData([...filteredData]);
      }
    }
  }, [chatCountPerPagePerDaySubscriptionResult]);

  useEffect(() => {
    if (storedAgentId !== 0) {
      setTotalChatsGraphData([]);
      getChatCountForSocialMedia({
        variables: {
          source: "all",
          agentId: [storedAgentId],
          timeFrame: timePeriod,
        },
      });
    } else {
      setTotalChatsGraphData([]);
      getChatCountForSocialMedia({
        variables: { source: "all", timeFrame: timePeriod },
      });
    }
  }, [storedAgentId, timePeriod]);

  useEffect(() => {
    setTotalChatsGraphDataLoading(graphDataLoading);
  }, [graphDataLoading]);

  useEffect(() => {
    if (graphDataResult && graphDataResult.getChatCountPerPagePerDay) {
      if (graphDataResult.getChatCountPerPagePerDay.success) {
        const data = safeJsonParse<any[]>(
          graphDataResult.getChatCountPerPagePerDay.result,
          [],
          "Graph Data",
        );

        setTotalChatsGraphData((prev: any) => [...prev, ...data]);
      } else {
        enqueueSnackbar(graphDataResult.getChatCountPerPagePerDay.error, {
          variant: "error",
        });
      }
    }
  }, [graphDataResult]);

  const seriesLegends = [
    {
      name: "Facebook",
      color: "#1877F2",
    },
    {
      name: "WhatsApp",
      color: "#60D669",
    },
    {
      name: "Instagram",
      color: "#B336AA",
    },
    {
      name: "Chatbot",
      color: "#FF9800",
    },
  ];

  return (
    <Box className={classes.rootBox}>
      {/*  */}
      <Box className={classes.header}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          className={classes.innerHeader}
        >
          {seriesLegends.map((s) => (
            <Stack key={s.name} direction="row" spacing={1} alignItems="center">
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: s.color,
                }}
              />
              <Typography className={classes.headerRightText}>
                {s.name}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
      {graphDataLoading && (
        <Box className={classes.progressBox}>
          <PendingSkeleton />
        </Box>
      )}
      {!graphDataLoading && next7Days.length > 0 && (
        <ReactApexChart
          className={classes.apex}
          height={322}
          type="line"
          series={series}
          options={options}
        />
      )}
    </Box>
  );
};

export default Graph;
